import { textFormatting } from '@yola/ws-sdk';

const { wrappersTypes: types } = textFormatting.constants;
const getSupportedTagNames = () => Object.values(types).map((type) => type.tagName);

export default getSupportedTagNames;
